import { render, staticRenderFns } from "./add-license.vue?vue&type=template&id=72da682e"
import script from "./add-license.vue?vue&type=script&lang=js"
export * from "./add-license.vue?vue&type=script&lang=js"
import style0 from "./add-license.vue?vue&type=style&index=0&id=72da682e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports